import { render, staticRenderFns } from "./DocumentTemplateDetailPageListMobile.vue?vue&type=template&id=9f8438da&scoped=true&"
import script from "./DocumentTemplateDetailPageListMobile.vue?vue&type=script&lang=ts&"
export * from "./DocumentTemplateDetailPageListMobile.vue?vue&type=script&lang=ts&"
import style1 from "./DocumentTemplateDetailPageListMobile.vue?vue&type=style&index=1&id=9f8438da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8438da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VDivider,VImg,VSheet})
